var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 147,
    viewBox: "0 0 103 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9971 192.599C31.1284 179.973 13.2528 158.383 5.30266 132.578C-2.64743 106.772 -0.0207978 78.8657 12.6048 54.997C25.2303 31.1283 46.8205 13.2527 72.6259 5.30261C98.4312 -2.64749 126.338 -0.0208502 150.206 12.6047L145.644 21.2301C124.063 9.81457 98.8309 7.43968 75.4988 14.6278C52.1667 21.816 32.6457 37.9784 21.2301 59.5595C9.81463 81.1406 7.43973 106.373 14.6279 129.705C21.816 153.037 37.9784 172.558 59.5595 183.973L54.9971 192.599Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.e83aa8a253b8428ff347d7b689471284.svg";
export { ForwardRef as ReactComponent };